import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FiImageMediaPanelComponent } from './fi-image-media-panel.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiTextItemMediaPanelHandlerModule } from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-handler.module';

@NgModule({
    declarations: [FiImageMediaPanelComponent],
    imports: [
        CommonModule,
        FormsModule,
        FiAppTextSharedModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        FiTextItemMediaPanelHandlerModule,
    ],
    exports: [FiImageMediaPanelComponent],
})
export class FiImageMediaPanelModule {}
